import {DataTableColumn} from 'mantine-datatable';
import {NavLink} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {Badge} from '@mantine/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {ApplicationScreenshot} from '../types';
import config from '../config';

const statusColor = (status?: string) => {
    switch (status) {
        case 'COMPLETED':
            return 'green';
        case 'PROCESSING':
            return 'blue';
        case 'PENDING':
            return 'yellow';
        case 'FAILED':
            return 'red';
        default:
            return 'gray';
    }
};

export const useApplicationScreenshotsTableColumns = () => {

    // Every column carries an `accessor` as well as a `render`. The accessor is what
    // the sort reads; a render-only column looks complete and is unsortable (FNP-1353).
    const columns: DataTableColumn<ApplicationScreenshot>[] = [
        {
            accessor: 'url',
            sortable: true,
            title: I18n.get('URL'),
            width: '1fr',
            render: (item: ApplicationScreenshot) => (
                <NavLink to={`${config.basePath}/${encodeURIComponent(item.id)}`}>
                    {item.url}{item.path ? `/${item.path}` : ''}
                </NavLink>
            ),
        },
        {
            accessor: 'status',
            sortable: true,
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: ApplicationScreenshot) => <Badge color={statusColor(item.status)}>{item.status}</Badge>,
        },
        {
            accessor: 'viewportWidth',
            sortable: true,
            title: I18n.get('Viewport'),
            width: '1fr',
            render: (item: ApplicationScreenshot) => `${item.viewportWidth || 1920}x${item.viewportHeight || 1080}`,
        },
        {
            accessor: 'fullPage',
            sortable: true,
            title: I18n.get('Full Page'),
            width: '1fr',
            render: (item: ApplicationScreenshot) => item.fullPage ? I18n.get('Yes') : I18n.get('No'),
        },
        {
            accessor: 'created',
            sortable: true,
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: ApplicationScreenshot) => formatTimestamp(item.created),
        },
    ];

    return columns;
};
